/* the function receives a number and parses it with decimals or as an integer. It works for cases where the number arrives with a .00 decimal place */
export const formatIntegerOrDecimal = (number) => {
    if (number == null) return '-';
    if (number?.toString() === '0' || number?.toString() === '0.00') return '0';
    const num = parseFloat(number);

    if (isNaN(num) || num === 0) return '-';

    if (num % 1 === 0) return num.toFixed(0);

    return num;
};
